import { post, get, put, del } from './api';

export const getCategories = query => get(`/categories`, query);
export const createNewCategory = values => post('/categories/create', values);
export const deleteCategory = id => del(`/categories/${id}`);
export const editCategory = (data, id) => put(`/categories/${id}`, data);
